/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */
import React, { ReactElement } from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import { TSeo } from './seo.types';
import ogImage from '../../static/ogImage.png';

export function Seo({ lang = 'en', title, description }: TSeo): ReactElement {
    const {
        site: { siteMetadata },
    } = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    title
                    description
                    url
                    twitterUsername
                    ogTitle
                }
            }
        }
    `);

    const metaDescription = description || siteMetadata.description;
    const defaultTitle = siteMetadata?.title;
    const siteUrl = siteMetadata?.url;
    const fullTitle = defaultTitle ? `${title} | ${defaultTitle}` : title;
    const ogImageAbsoluteUrl = siteUrl
        ? new URL(ogImage, siteUrl).toString()
        : undefined;

    return (
        <Helmet
            htmlAttributes={{ lang }}
            title={title}
            titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : undefined}
        >
            {siteMetadata.url && (
                <meta property="og:url" content={siteMetadata.url} />
            )}
            {fullTitle && (
                <meta property="og:title" content={siteMetadata.ogTitle} />
            )}
            <meta property="og:description" content={metaDescription} />
            <meta name="description" content={metaDescription} />
            {ogImageAbsoluteUrl && (
                <meta property="og:image" content={ogImageAbsoluteUrl} />
            )}

            <meta name="twitter:card" content="summary_large_image" />
            {siteMetadata.twitterUsername && (
                <meta
                    name="twitter:creator"
                    content={siteMetadata.twitterUsername}
                />
            )}
            {fullTitle && <meta name="twitter:title" content={fullTitle} />}
            <meta name="twitter:description" content={metaDescription} />
            {ogImageAbsoluteUrl && (
                <meta name="twitter:image" content={ogImageAbsoluteUrl} />
            )}
        </Helmet>
    );
}
